import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { FollowState } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollows } from "./useFollows"
import { useAccount } from "src/hooks/account"

const defaultValue: Follow[] = []

/*
 * this hook returns the follows that represent this account sharing its data
 * with another account but not itself
 */
export function useSharingFollows() {
  const { data: follows } = useFollows()
  const { data: account } = useAccount()

  return useMemo(
    () => account === undefined || follows == undefined
      ? defaultValue
      : follows.filter(
        (follow) => !follow.is_self &&
          follow.deleted_at === null &&
          follow.following_account_id === account.id &&
          follow.state !== FollowState.Terminated,
      ),
    [
      follows,
      account,
    ],
  )
}

